<template>
  <div class="coupon-stats-container">

    <!-- 数据概览卡片 -->
    <div class="overview-cards">
      <el-card class="stat-card">
        <div class="card-content">
          <div class="card-title">今日领取</div>
          <div class="amount">{{ todayAmount }}元</div>
          <div class="count">{{ todayCount }}个</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="card-content">
          <div class="card-title">本周领取</div>
          <div class="amount">{{ weekAmount }}元</div>
          <div class="count">{{ weekCount }}个</div>
        </div>
      </el-card>
      <el-card class="stat-card">
        <div class="card-content">
          <div class="card-title">本月领取</div>
          <div class="amount">{{ monthAmount }}元</div>
          <div class="count">{{ monthCount }}个</div>
        </div>
      </el-card>
    </div>

     <el-card class="data-section">
      <div slot="header" class="section-header">
        <span>用户排行榜</span>
        <div class="leaderboard-tabs">
          <el-radio-group v-model="leaderboardType" size="small">
            <el-radio-button label="amount">金额排行</el-radio-button>
            <el-radio-button label="count">数量排行</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <el-table :data="currentLeaderboard" style="width: 100%">
        <el-table-column label="排名" width="80">
          <template slot-scope="scope">
            <span v-if="scope.$index < 3" class="top-rank">{{ scope.$index + 1 }}</span>
            <span v-else>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户" width="200">
          <template slot-scope="scope">
            <div class="user-info">
              <el-avatar :src="scope.row.avatarUrl" size="small"></el-avatar>
              <span class="nickname">{{ scope.row.nickName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="total_amount" label="总金额" width="120">
          <template slot-scope="scope">
            {{ scope.row.total_amount }}元
          </template>
        </el-table-column>
        <el-table-column prop="coupon_count" label="总数量" width="120">
          <template slot-scope="scope">
            {{ scope.row.coupon_count }}个
          </template>
        </el-table-column>
        <el-table-column prop="max_amount" label="最高金额" width="120">
          <template slot-scope="scope">
            {{ scope.row.max_amount }}元
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 红包明细表格 -->
    <el-card class="data-section">
      <div slot="header" class="section-header">
        <span>红包明细</span>
      </div>
      <el-table :data="couponList" style="width: 100%" empty-text="暂无红包记录">
        <el-table-column prop="name" label="红包名称" width="180"></el-table-column>
        <el-table-column prop="hb_price" label="金额" width="100">
          <template slot-scope="scope">
            <span style="color: #f56c6c">+{{ scope.row.hb_price }}金币·</span>
          </template>
        </el-table-column>
        <el-table-column prop="hb_product" label="关联商品" width="180"></el-table-column>
        <el-table-column prop="create_time" label="领取时间" width="180"></el-table-column>
      </el-table>
    </el-card>

    <!-- 排行榜 -->
   
  </div>
</template>

<script>
import StatisticsApi from '@/api/statistics.js';

export default {
  data() {
    return {
      activeTab: '今日',
      tabs: [
        { label: '今日', value: '今日' },
        { label: '本周', value: '本周' },
        { label: '本月', value: '本月' }
      ],
      todayAmount: '0.00',
      weekAmount: '0.00',
      monthAmount: '0.00',
      todayCount: 0,
      weekCount: 0,
      monthCount: 0,
      couponList: [],
      timeRange: {
        start: '',
        end: ''
      },
      leaderboardType: 'amount',
      leaderboard: {
        byAmount: [],
        byCount: []
      }
    }
  },
  computed: {
    currentLeaderboard() {
      return this.leaderboardType === 'amount' 
        ? this.leaderboard.byAmount 
        : this.leaderboard.byCount;
    }
  },
  created() {
    this.fetchStats();
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab;
      this.fetchStats();
    },
    async fetchStats() {
      try {
        StatisticsApi.stats(this.activeTab).then((res) => {
          const data = res.data;
          this.todayAmount = data.todayAmount;
          this.weekAmount = data.weekAmount;
          this.monthAmount = data.monthAmount;
          this.todayCount = data.todayCount;
          this.weekCount = data.weekCount;
          this.monthCount = data.monthCount;
          this.couponList = data.list;
          this.timeRange = data.timeRange;
          this.leaderboard = data.leaderboard;
        });
      } catch (error) {
        console.error('获取统计信息失败:', error);
        this.$message.error('获取统计信息失败');
      }
    }
  }
}
</script>

<style scoped>
.coupon-stats-container {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 60px);
}

.header-section {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.page-title {
  margin: 0 0 20px 0;
  font-size: 20px;
  color: #333;
}

.filter-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.time-range {
  color: #999;
  font-size: 14px;
}

.overview-cards {
  display: flex;
  margin-bottom: 20px;
  gap: 20px;
}

.stat-card {
  flex: 1;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.card-content {
  padding: 15px;
  text-align: center;
}

.card-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.amount {
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 5px;
}

.count {
  font-size: 14px;
  color: #999;
}

.data-section {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.leaderboard-tabs {
  margin-left: 20px;
}

.user-info {
  display: flex;
  align-items: center;
}

.nickname {
  margin-left: 10px;
}

.top-rank {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background-color: #f56c6c;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/red/index.vue